export default __webpack_public_path__ + "static/media/311.b3cdb9be.jpg";